// Loads the Cloudflare Turnstile script once and resolves with the global
// `window.turnstile` object. We use explicit rendering (render=explicit) so the
// widget is only mounted by our React component, rather than auto-scanning the
// DOM for `.cf-turnstile` elements (which does not play well with client-side
// routing and re-renders).
const TURNSTILE_SRC =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let turnstilePromise = null;

const loadTurnstile = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(
      new Error('Turnstile is only available in the browser')
    );
  }
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }
  if (turnstilePromise) {
    return turnstilePromise;
  }

  turnstilePromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src^="${TURNSTILE_SRC}"]`);
    const script = existing ?? document.createElement('script');

    const handleLoad = () => {
      if (window.turnstile) {
        resolve(window.turnstile);
      } else {
        turnstilePromise = null;
        reject(new Error('Turnstile loaded but is not available'));
      }
    };
    const handleError = () => {
      turnstilePromise = null;
      reject(new Error('Failed to load the Turnstile script'));
    };

    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);

    if (!existing) {
      script.src = TURNSTILE_SRC;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    } else if (window.turnstile) {
      // Script tag already present and initialised.
      handleLoad();
    }
  });

  return turnstilePromise;
};

export default loadTurnstile;
